// <copyright file="auth-constants.ts" company="BD">
// Copyright (c) BD. All rights reserved.
// Created: 02/10/2026 by Sumanth Satheesh
// </copyright>

/**
 * Placeholder token returned by the SSO provider when a session is already active.
 * This token is not usable and should trigger a redirect to login if encountered.
 */
export const sessionAlreadyActiveToken = "00000000-0000-0000-0000-000000000000";

/**
 * Checks if a token is usable (non-null and not a placeholder).
 *
 * @param token - The token string to check
 * @returns true if token exists and is not a placeholder
 */
export const isUsableToken = (token: string | null): boolean =>
  !!token && token !== sessionAlreadyActiveToken;
